import './LoadingSpinner.css';

const LoadingSpinner = ({ text = 'Loading...' }: { text?: string }) => {
  return (
    <div className="loading-spinner-overlay">
      <div className="loading-spinner"></div>
      <div className="loading-spinner-text">{text}</div>
    </div>
  );
};

export default LoadingSpinner;
